import React from 'react';
import {
  Card,
  CardContent,
  Typography
} from '@mui/material';
import { BaseTable } from 'src/components/BaseTable/BaseTable';

const AnalyticsTable = ({
  title,
  rows = [],
  columns = [],
  pageSize = 10,
  rowsPerPageOptions = [10, 25, 50],
  showPagination = true,
  showExportCsvBtn = false,
  serverRowFetcher = false,
  sx = {}
}) => {
  const defaultSx = {
    ".MuiDataGrid-columnHeaderTitle": {
      overflow: "hidden !important",
      lineHeight: "20px !important",
      whiteSpace: "normal !important",
    },
    ...sx
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <BaseTable
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          pageSize={pageSize}
          rowsPerPageOptions={rowsPerPageOptions}
          pagination={showPagination}
          showExportCsvBtn={showExportCsvBtn}
          serverRowFetcher={serverRowFetcher}
          sx={defaultSx}
        />
      </CardContent>
    </Card>
  );
};

export default AnalyticsTable;
